/**
 * Shared chrome for the standalone pages a prospect reaches from outside this
 * app's own navigation - an emailed link, or Stripe redirecting back. Unlike
 * FlowShell, there is no step indicator: these pages are not part of the
 * ordered qualify/account/trial sequence and do not claim to be.
 */

import { ReactNode } from 'react';
import styles from './index.module.css';

const StandaloneShell = ({ children }: { children: ReactNode }) => (
  <div className={styles.wrap}>
    <div className={styles.wordmark}>AVRIO</div>
    {children}
  </div>
);

export default StandaloneShell;
